const fetchAll = async (entity, company, token, gatewayEntryId = "") => {
  const log = window.log('fetchAll');
  const request = await fetch(
    `${process.env.REACT_APP_API_URL}/${entity}/get?sensorMAC&gatewayEntryId=${gatewayEntryId}`,
    {
      headers: {
        "Content-Type": "application/json",
        Authorization: token,
      },
    }
  );

  const json = await request.json();
  return json;
};

export default fetchAll;
